import { unsavedFormChangesActionTypes as ACTION } from '../actionTypes';

const initialState = {
  isChanged: false,
};

const UnsavedFormChangesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SET_FORM_DATA: {
      const { key, value } = action.payload;
      return {
        ...state,
        [key]: value,
      };
    }
    case ACTION.SET_FORM_STATUS: {
      return {
        ...state,
        isChanged: action.payload,
      };
    }
    case ACTION.RESET_FORM_CHANGES: {
      return {
        isChanged: false,
      };
    }
    default:
      return state;
  }
};

export default UnsavedFormChangesReducer;
